function Home() {
    return (
        <h2>Click on a link to get started!</h2>
    );
}

export default Home;